import * as React from 'react'

import { ReactComponent as CloseIcon } from 'assets/images/svg/close_circle.svg'

import styles from './AppModal.module.scss'

interface Props {
  onClose?(): void
  title?: string
}
export const AppModalHeader: React.FC<Props> = ({ title, onClose }) => {
  return (
    <div style={{ width: '100%' }}>
      <div className={styles.title}>
        <span>{title}</span>
        <div className={styles.close}>
          <div className={styles.closeButton} onClick={onClose}>
            <CloseIcon />
          </div>
        </div>
      </div>
    </div>
  )
}
